import {BaseModel} from "@/store/models/household/BaseModel";
import store from "@/store";

export default class ClientPortalSetting extends BaseModel{
    static entity = 'App\\Models\\Company\\ClientPortalSetting';
    static modelKey = 'client-portal-settings'
    static fields() {
        return {
            id: this.attr(null),
            email: this.attr(null),
            company_id: this.attr(''),
            phone_number: this.attr(null),
            schedule_meetings_link: this.attr(null),
            calendar_link: this.attr(null),
            networth_page: this.boolean(false),
            accounts_page: this.boolean(false),
            my_plan_page: this.boolean(false),
            performance_page: this.boolean(false),
            positions_page: this.boolean(false),
            newsletters_page: this.boolean(false),
            dashboard_page: this.boolean(false),
            assets_liabilities_page: this.boolean(true),
            show_benchmarks: this.boolean(false)
        }
    }

    static getCompanySetting(companyId) {
        return this.api().get(`companies/${companyId}/clientPortalSetting`).then(({response}) => {
            store.commit('auth/setClientPortalSetting', response.data.data);
            return response;
        });
    }
}
